import React, { useState } from "react";

import {
  Box,
  CardHeader,
  Collapse,
  Hidden,
  Card as MuiCard,
  TypographyProps,
} from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

import { Button } from "../index";
import Body, { BodyProps } from "./Body";
import Toolbar, { ToolbarProps } from "./Toolbar";

interface Props {
  children: React.ReactNode;
  collapsable?: boolean;
  subtitle?: string;
  title?: React.ReactNode;
}

interface Composition {
  Body: React.FC<BodyProps>;
  Toolbar: React.FC<ToolbarProps>;
}

const Card: React.FC<Props> & Composition = ({
  children,
  collapsable,
  subtitle,
  title,
}: Props) => {
  const [collapsed, setCollapsed] = useState(true);

  function handleCollapse() {
    setCollapsed(!collapsed);
  }

  let toolbar,
    content = React.Children.toArray(children);
  if (
    content.length &&
    React.isValidElement(content[0]) &&
    content[0].type === Toolbar
  ) {
    toolbar = content.splice(0, 1)[0];
  }

  const collapseIcon = collapsed ? ExpandMore : ExpandLess;

  const titleProps: TypographyProps = {
    variant: "h2",
  };

  return (
    <MuiCard>
      <Box alignItems="center" display="flex">
        <Box flexGrow={1}>
          <CardHeader
            subheader={subtitle}
            title={title}
            titleTypographyProps={titleProps}
          />
        </Box>
        {toolbar}
        {collapsable && (
          <Hidden mdUp>
            <Box displayPrint="none" marginRight={1}>
              <Button
                color="default"
                icon={collapseIcon}
                outlined
                onClick={handleCollapse}
              />
            </Box>
          </Hidden>
        )}
      </Box>
      {collapsable ? (
        <React.Fragment>
          <Hidden mdUp>
            <Collapse in={!collapsed}>{content}</Collapse>
          </Hidden>
          <Hidden smDown>{content}</Hidden>
        </React.Fragment>
      ) : (
        content
      )}
    </MuiCard>
  );
};

Card.Body = Body;
Card.Toolbar = Toolbar;

export default Card;
